type OrganizationBadgeProps = {
  organization: string;
};

export const OrganizationBadge = ({
  organization,
}: OrganizationBadgeProps) => (
  <div
    className="arx-corporate-header__organization"
    aria-label={`Organização ativa: ${organization}`}
  >
    <span className="arx-corporate-header__label">Organização</span>
    <strong>{organization}</strong>
  </div>
);
